import GetInTouch from "components/getInTouch";
import Featured from "components/homepage/featured";
import Reviews from "components/homepage/reviews";
import TranslateAgency from "components/homepage/translateAgency";
import TranslationServices from "components/homepage/translationServices";
import WhatChooseUs from "components/homepage/whyChooseUs";
import Layout from "components/layout";
import LocationBanner from "components/locationBanner";
import SEO from "components/seo";
import React, { useEffect, useState } from "react";

const Languages = (props) => {
  const title = "About us | Tomedes Translation Services";
  const description =
    "TOMEDES is a leading translation agency with more than 25,000 business customers and thousands of professional translators. Want to get in touch with us? - support@tomedes.com | +1 985 239 0142";
  const keywords = "about tomedes, about translation company";
  const slug = "/about-tomedes";
  const {
    pageContext: {
      data: { data },
    },
  } = props;

  const useExperiment = (experimentId) => {
    const [variant, setVariant] = useState();
    useEffect(() => {
      (async () => {
        if (window.dataLayer) {
          await window.dataLayer.push({ event: "optimize.activate" });
        }
        const intervalId = setInterval(() => {
          if (window.google_optimize !== undefined) {
            // Set the variant to the state.
            setVariant(window.google_optimize.get(experimentId));
            clearInterval(intervalId);
          }
        }, 100);
      })();
    });
    return variant;
  };

  const variant = useExperiment("0t419afbTt2SZAdAwyUTdg");
  const variant_mobile = useExperiment("qTbb91wkRi-Z-X1ZByebNw");

  return (
    <Layout>
      {data.slug === slug ? (
        <SEO
          title={title}
          description={description}
          keywords={keywords}
          slug={slug}
        />
      ) : (
        <>
          <SEO
            title={data.Title_tag_value}
            description={data.Meta_tag_desc}
            keywords={data.Meta_tag_keywords}
            slug={data.slug}
          />
          <LocationBanner
            title={data.title_x}
            content={data.Meta_tag_desc}
            formOrangeHead="Get in touch"
            formWhiteHead=""
            backgroundCol="bg-midBlue"
            styleOne={variant || variant_mobile}
            // styleOne="1"
          />
          <TranslateAgency styleOne={variant || variant_mobile} />
        </>
      )}
      <div
        className={"service_wrapper " + data.slug.replace(/[^a-zA-Z]+/g, "")}
        dangerouslySetInnerHTML={{ __html: data.SEOCMSPageContent }}
      />

      <Reviews backgroundCol="bg-midBlue" />
      <TranslationServices
        backgroundCol="bg-darkBlue"
        styleOne={variant || variant_mobile}
        // styleOne="1"

      />
      <Featured backgroundCol="bg-midBlue" />
      <WhatChooseUs backgroundCol="bg-darkBlue" />
      <GetInTouch backgroundCol="bg-midBlue" />
    </Layout>
  );
};

export default Languages;
